<slb-navigation-framework id="userSetting" class="userSetting-container" [secondaryNavigationItems]="secondaryNavigationItems">
  <slb-framework-content>
    <ng-content *ngTemplateOutlet="content"></ng-content>
  </slb-framework-content>
  <ng-template #content>
    <router-outlet></router-outlet>
  </ng-template>
</slb-navigation-framework>
